import React from "react";

interface IAsyncComponentProps {
    resolve: () => Promise<React.ComponentType | null> | React.ComponentType | null;
    placeholder?: React.ReactNode;
    [key: string]: unknown;
}
interface IAsyncComponentState {
    hasComponent: boolean;
}

export default class AsyncComponent extends React.PureComponent<IAsyncComponentProps, IAsyncComponentState> {
    public state = {
        hasComponent: false,
    };
    private _component: React.ComponentType | null = null;
    private _isMounted = false;

    public render() {
        const { placeholder, ...props } = this.props;
        let Component: React.ComponentType | null;
        if (this.state.hasComponent) {
            Component = this._component;
        } else if (placeholder !== undefined) {
            Component = placeholder as React.ComponentType;
        } else {
            Component = null;
        }

        return Component !== null ? <Component {...props} /> : Component;
    }

    public componentDidMount() {
        this._isMounted = true;
        const resolved = this.props.resolve();

        if (resolved && typeof resolved == "object") {
            if (resolved.then) {
                resolved.then(component => {
                    if (component) {
                        this._updateComponent(component);
                    }
                });
            } else {
                this._updateComponent((resolved as unknown) as React.ComponentType);
            }
        }
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    private _updateComponent = (component: React.ComponentType) => {
        window?.requestAnimationFrame(() => {
            if (this._isMounted) {
                this._component = component;
                this.setState({ hasComponent: true });
            }
        });
    };
}
